import React from 'react';

import { Box, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Button from 'src/Lca/components/Button';
import { SubcategoryModal as Props } from './index.types';
import ButtonArea from '../ButtonArea';

import { getUniqueSubcategoryGroups } from '../../helpers';
import { useTranslation } from 'react-i18next';
import {
  getLifecycleCategoryLabel,
  getLifecycleSubcategoryGroupLabel,
  getLifecycleSubcategoryLabel,
} from 'src/Lca/LCADiagram/labels';

export default function SubcategoryModal({
  category,
  onSubcategoryClick,
  onClose,
}: Props) {
  const { t } = useTranslation('lca');
  const { subcategories } = category;
  const groups = getUniqueSubcategoryGroups(subcategories);
  const categoryLabel = getLifecycleCategoryLabel(
    t,
    category.key,
    category.name
  );

  return (
    <Dialog open={!!category} onClose={onClose} maxWidth="lg">
      <IconButton
        sx={{ position: 'absolute', top: 12, right: 10, zIndex: 99 }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Box sx={{ m: '10px', mb: '20px', width: '900px' }}>
        {groups?.map((group) => {
          const translatedGroup = group
            ? getLifecycleSubcategoryGroupLabel(t, group, group)
            : '';
          const _group = translatedGroup ? `: ${translatedGroup}` : '';
          const header = `${categoryLabel}${_group}`;
          const _subcategories = subcategories.filter(
            (sc) => sc.group === group
          );
          return (
            <ButtonArea
              key={header}
              header={header}
              contentWrapperStyles={{ flexWrap: 'wrap', gap: 20 }}
            >
              {_subcategories.map((subcategory) => (
                <Button
                  onClick={() => onSubcategoryClick(subcategory)}
                  key={`${header}-${subcategory.id}`}
                  color={category.key}
                >
                  {getLifecycleSubcategoryLabel(
                    t,
                    subcategory.name,
                    subcategory.name
                  )}
                </Button>
              ))}
            </ButtonArea>
          );
        })}
      </Box>
    </Dialog>
  );
}
